// extracted by mini-css-extract-plugin
export default {"bankCard":"BankCard_bankCard","bankCardImage":"BankCard_bankCardImage","bankCardInfo":"BankCard_bankCardInfo"};